import NewRequest from './fetcher/newRequest.js'

// 登录
export function loginApi (data) {
  data = Object.assign(
    { login_type: 2, token: '', plat: 0, tel: '', tel_code: '' },
    data
  )
  return NewRequest.post('/api/sdk/user/login', data)
}

/** 发送手机验证码 */
export function sendVerifyCode (data) {
  return NewRequest.post('/api/sdk/sms/send_code', data)
}

// 获取图形验证码
export function getCaptchaApi (data) {
  return NewRequest.post('/api/sdk/sms/captcha', data)
}

// 校验图形验证码
export function checkCaptchaApi (data) {
  return NewRequest.post('/api/sdk/sms/captcha_check', data)
}

export function getToken (data) {
  return NewRequest.post('/api/sdk/user/token', data)
}
// 用当前产品的token换另外一个产品的token
export function exchangeToken (data) {
  return NewRequest.post('/api/sdk/user/token_change', data)
}
/**
 * 长码回传
 * @param {RequestParams} data
 */
export function updateConvertData (data) {
  return NewRequest.post('/api/sdk/ocpc/bd/update_convert_data', data)
}